/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddPatchPastiDipendentiDTO } from '../model/addPatchPastiDipendentiDTO';
import { CalendarioScolastico } from '../model/calendarioScolastico';
import { CalendarioScolasticoForm } from '../model/calendarioScolasticoForm';
import { ChiusuraScolastica } from '../model/chiusuraScolastica';
import { ChiusuraScolasticaForAllForm } from '../model/chiusuraScolasticaForAllForm';
import { ChiusuraScolasticaForm } from '../model/chiusuraScolasticaForm';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { GenericResponseDTO } from '../model/genericResponseDTO';
import { GetDettagliScuolaDTO } from '../model/getDettagliScuolaDTO';
import { GetScuolaView } from '../model/getScuolaView';
import { GetSezioniClassiDTO } from '../model/getSezioniClassiDTO';
import { PastiDipendenti } from '../model/pastiDipendenti';
import { Scuola } from '../model/scuola';
import { ScuolaCreationForm } from '../model/scuolaCreationForm';
import { ScuolaEditForm } from '../model/scuolaEditForm';
import { ScuolaUpdateForm } from '../model/scuolaUpdateForm';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ScuoleService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette ad un account ADMIN o OP_SCUOLA di creare un calendario scolastico per una scuola.
     * Crea il calendario scolastico per la scuola specificata definendo le date di inizio e fine anno. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body Attributi del calendario scolastico.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<CalendarioScolastico>;
    public addCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CalendarioScolastico>>;
    public addCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CalendarioScolastico>>;
    public addCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addCalendarioScolasticoScuola.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling addCalendarioScolasticoScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CalendarioScolastico>('post',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/calendario-scolastico`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN di creare una chiusura scolastica per tutte le scuole.
     * Crea in blocco una chiusura scolastica applicata a una lista di scuole. Accessibile solo agli utenti ADMIN.
     * @param body Attributi della chiusura scolastica.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addChiusuraScolasticaForAllScuole(body: ChiusuraScolasticaForAllForm, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public addChiusuraScolasticaForAllScuole(body: ChiusuraScolasticaForAllForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public addChiusuraScolasticaForAllScuole(body: ChiusuraScolasticaForAllForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public addChiusuraScolasticaForAllScuole(body: ChiusuraScolasticaForAllForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addChiusuraScolasticaForAllScuole.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GenericResponseDTO>('post',`${this.basePath}/api/v1/scuola/chiusura-scolastica-for-all`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di creare una chiusura scolastica per una scuola.
     * Registra una nuova chiusura scolastica (es. festività, assemblea) per la scuola specificata, con possibilità di limitarla a una classe o sezione. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body Attributi della chiusura scolastica.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<CalendarioScolastico>;
    public addChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CalendarioScolastico>>;
    public addChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CalendarioScolastico>>;
    public addChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addChiusuraScolasticaScuola.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling addChiusuraScolasticaScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CalendarioScolastico>('post',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/chiusura-scolastica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di censire una nuova scuola&#x27;.
     * Crea una nuova scuola nel sistema associandola al comune specificato. Accessibile solo agli utenti ADMIN.
     * @param body Scuola da aggiungere.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addScuola(body: ScuolaCreationForm, observe?: 'body', reportProgress?: boolean): Observable<Scuola>;
    public addScuola(body: ScuolaCreationForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Scuola>>;
    public addScuola(body: ScuolaCreationForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Scuola>>;
    public addScuola(body: ScuolaCreationForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Scuola>('post',`${this.basePath}/api/v1/scuola/add`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di clonare il calendario scolastico di un&#x27;altra scuola.
     * Copia il calendario scolastico di una scuola sorgente sulla scuola di destinazione. Se il parametro &#x27;forced&#x27; è true, sovrascrive il calendario esistente. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param id_scuola 
     * @param id_scuola_da_clonare 
     * @param forced 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clonaCalendarioScolasticoScuola(id_scuola: string, id_scuola_da_clonare: string, forced?: boolean, observe?: 'body', reportProgress?: boolean): Observable<CalendarioScolastico>;
    public clonaCalendarioScolasticoScuola(id_scuola: string, id_scuola_da_clonare: string, forced?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CalendarioScolastico>>;
    public clonaCalendarioScolasticoScuola(id_scuola: string, id_scuola_da_clonare: string, forced?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CalendarioScolastico>>;
    public clonaCalendarioScolasticoScuola(id_scuola: string, id_scuola_da_clonare: string, forced?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling clonaCalendarioScolasticoScuola.');
        }

        if (id_scuola_da_clonare === null || id_scuola_da_clonare === undefined) {
            throw new Error('Required parameter id_scuola_da_clonare was null or undefined when calling clonaCalendarioScolasticoScuola.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_scuola_da_clonare !== undefined && id_scuola_da_clonare !== null) {
            queryParameters = queryParameters.set('id_scuola_da_clonare', <any>id_scuola_da_clonare);
        }
        if (forced !== undefined && forced !== null) {
            queryParameters = queryParameters.set('forced', <any>forced);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CalendarioScolastico>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/calendario-scolastico/clona`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di modificare un calendario scolastico per una scuola.
     * Aggiorna le date di inizio e fine del calendario scolastico esistente per la scuola specificata. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body Attributi del calendario scolastico da modificare.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<CalendarioScolastico>;
    public editCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CalendarioScolastico>>;
    public editCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CalendarioScolastico>>;
    public editCalendarioScolasticoScuola(body: CalendarioScolasticoForm, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling editCalendarioScolasticoScuola.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling editCalendarioScolasticoScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CalendarioScolastico>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/calendario-scolastico`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di modificare una chiusura scolastica per una scuola.
     * Aggiorna i dati di una chiusura scolastica esistente per la scuola specificata. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body Attributi della chiusura scolastica da modificare.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<ChiusuraScolastica>;
    public editChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ChiusuraScolastica>>;
    public editChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ChiusuraScolastica>>;
    public editChiusuraScolasticaScuola(body: ChiusuraScolasticaForm, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling editChiusuraScolasticaScuola.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling editChiusuraScolasticaScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ChiusuraScolastica>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/chiusura-scolastica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account Amministratore di modificare una scuola esistente.
     * Aggiorna i dati di una scuola esistente nel sistema. Accessibile solo agli utenti ADMIN.
     * @param body Scuola da aggiungere.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editScuola(body: ScuolaEditForm, observe?: 'body', reportProgress?: boolean): Observable<GetScuolaView>;
    public editScuola(body: ScuolaEditForm, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetScuolaView>>;
    public editScuola(body: ScuolaEditForm, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetScuolaView>>;
    public editScuola(body: ScuolaEditForm, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling editScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GetScuolaView>('put',`${this.basePath}/api/v1/scuola/edit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di ottenere il calendario scolastico della scuola con id fornito.
     * Restituisce il calendario scolastico attivo per la scuola identificata dall&#x27;ID fornito. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCalendarioScolasticoScuola(id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<CalendarioScolastico>;
    public getCalendarioScolasticoScuola(id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CalendarioScolastico>>;
    public getCalendarioScolasticoScuola(id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CalendarioScolastico>>;
    public getCalendarioScolasticoScuola(id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling getCalendarioScolasticoScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CalendarioScolastico>('get',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/calendario-scolastico`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di ottenere i dettagli di tutte le scuole di un comune.
     * Restituisce per ogni scuola del comune i dettagli completi incluse sezioni e classi degli studenti iscritti. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param slugComune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDettagliScuoleSezioniClassi(slugComune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<GetDettagliScuolaDTO>>;
    public getDettagliScuoleSezioniClassi(slugComune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<GetDettagliScuolaDTO>>>;
    public getDettagliScuoleSezioniClassi(slugComune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<GetDettagliScuolaDTO>>>;
    public getDettagliScuoleSezioniClassi(slugComune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getDettagliScuoleSezioniClassi.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<GetDettagliScuolaDTO>>('get',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(slugComune))}/dettagli-scuole`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di leggere i dati relativi ai pasti dipendenti.
     * Restituisce le informazioni sui pasti consumati dai dipendenti per la scuola specificata. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPastiDipendenti(id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<PastiDipendenti>;
    public getPastiDipendenti(id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PastiDipendenti>>;
    public getPastiDipendenti(id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PastiDipendenti>>;
    public getPastiDipendenti(id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling getPastiDipendenti.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PastiDipendenti>('get',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/pasti-dipendenti`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di ottenere le sezioni e le classi per la scuola con id fornito.
     * Restituisce l&#x27;elenco delle sezioni e classi presenti nella scuola specificata, derivato dagli studenti iscritti. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSezioniClassiScuola(id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<GetSezioniClassiDTO>;
    public getSezioniClassiScuola(id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSezioniClassiDTO>>;
    public getSezioniClassiScuola(id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSezioniClassiDTO>>;
    public getSezioniClassiScuola(id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling getSezioniClassiScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetSezioniClassiDTO>('get',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/sezioni-classi`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di eliminare una chiusura scolastica per una scuola.
     * Elimina la chiusura scolastica identificata dall&#x27;ID fornito per la scuola specificata. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param id_scuola 
     * @param id_chiusura_scolastica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeChiusuraScolasticaScuola(id_scuola: string, id_chiusura_scolastica: string, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public removeChiusuraScolasticaScuola(id_scuola: string, id_chiusura_scolastica: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public removeChiusuraScolasticaScuola(id_scuola: string, id_chiusura_scolastica: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public removeChiusuraScolasticaScuola(id_scuola: string, id_chiusura_scolastica: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling removeChiusuraScolasticaScuola.');
        }

        if (id_chiusura_scolastica === null || id_chiusura_scolastica === undefined) {
            throw new Error('Required parameter id_chiusura_scolastica was null or undefined when calling removeChiusuraScolasticaScuola.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('delete',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/chiusura-scolastica/${encodeURIComponent(String(id_chiusura_scolastica))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di aggiornare i giorni della settimana di chiusura di una scuola gestita.
     * Imposta i giorni settimanali di chiusura della scuola (es. sabato e domenica). Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body giorni della settimana di chiusura da aggiornare.
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setGiorniDellaSettimanaDiChiusura(body: ScuolaUpdateForm, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<Scuola>;
    public setGiorniDellaSettimanaDiChiusura(body: ScuolaUpdateForm, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Scuola>>;
    public setGiorniDellaSettimanaDiChiusura(body: ScuolaUpdateForm, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Scuola>>;
    public setGiorniDellaSettimanaDiChiusura(body: ScuolaUpdateForm, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setGiorniDellaSettimanaDiChiusura.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling setGiorniDellaSettimanaDiChiusura.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Scuola>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/giorni-della-settimana-di-chiusura`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN di impostare il numero minimo di pasti da fatturare per una scuola (solo per comuni con gestione manuale).
     * Imposta la soglia minima di pasti mensili da considerare per la fatturazione. Applicabile solo ai comuni con modalità di pagamento MANUALE. Accessibile solo agli utenti ADMIN.
     * @param id_scuola 
     * @param numeroMinimoPastiDaFatturare 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setNumeroMinimoPastiDaFatturare(id_scuola: string, numeroMinimoPastiDaFatturare: number, observe?: 'body', reportProgress?: boolean): Observable<GenericResponseDTO>;
    public setNumeroMinimoPastiDaFatturare(id_scuola: string, numeroMinimoPastiDaFatturare: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GenericResponseDTO>>;
    public setNumeroMinimoPastiDaFatturare(id_scuola: string, numeroMinimoPastiDaFatturare: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GenericResponseDTO>>;
    public setNumeroMinimoPastiDaFatturare(id_scuola: string, numeroMinimoPastiDaFatturare: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling setNumeroMinimoPastiDaFatturare.');
        }

        if (numeroMinimoPastiDaFatturare === null || numeroMinimoPastiDaFatturare === undefined) {
            throw new Error('Required parameter numeroMinimoPastiDaFatturare was null or undefined when calling setNumeroMinimoPastiDaFatturare.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (numeroMinimoPastiDaFatturare !== undefined && numeroMinimoPastiDaFatturare !== null) {
            queryParameters = queryParameters.set('numeroMinimoPastiDaFatturare', <any>numeroMinimoPastiDaFatturare);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GenericResponseDTO>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/numero-minimo-pasti-da-fatturare`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette ad un account ADMIN o OP_SCUOLA di settare o aggiornare le info relative ai pasti dei dipendenti.
     * Imposta o aggiorna le informazioni sui pasti dei dipendenti per la scuola specificata. Accessibile agli utenti ADMIN e OP_SCUOLA.
     * @param body 
     * @param id_scuola 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setOrUpdatePastiDipendenti(body: AddPatchPastiDipendentiDTO, id_scuola: string, observe?: 'body', reportProgress?: boolean): Observable<Scuola>;
    public setOrUpdatePastiDipendenti(body: AddPatchPastiDipendentiDTO, id_scuola: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Scuola>>;
    public setOrUpdatePastiDipendenti(body: AddPatchPastiDipendentiDTO, id_scuola: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Scuola>>;
    public setOrUpdatePastiDipendenti(body: AddPatchPastiDipendentiDTO, id_scuola: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setOrUpdatePastiDipendenti.');
        }

        if (id_scuola === null || id_scuola === undefined) {
            throw new Error('Required parameter id_scuola was null or undefined when calling setOrUpdatePastiDipendenti.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Scuola>('put',`${this.basePath}/api/v1/scuola/${encodeURIComponent(String(id_scuola))}/pasti-dipendenti`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
